/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSON, FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSON, } from './FxIdApplicationHandlersAuthAuthenticateWithExternalIdState';
import { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensFromJSON, FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensToJSON, } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokens';
import { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsFromJSON, FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsToJSON, } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptions';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponse(value) {
    if (!('State' in value) || value['State'] === undefined)
        return false;
    if (!('Hint' in value) || value['Hint'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'State': FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSON(json['State']),
        'Tokens': json['Tokens'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensFromJSON(json['Tokens']),
        'Hint': json['Hint'],
        'Email': json['Email'] == null ? undefined : json['Email'],
        'TransferOptions': json['TransferOptions'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsFromJSON(json['TransferOptions']),
    };
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'State': FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSON(value['State']),
        'Tokens': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTokensToJSON(value['Tokens']),
        'Hint': value['Hint'],
        'Email': value['Email'],
        'TransferOptions': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsToJSON(value['TransferOptions']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponse.js.map